import { http } from "../http/Http";
import { Status } from "../models/Status";
import { ServiceResponse } from "../models/ServiceResponse";

export class StatusService {

    getStatuses = async (): Promise<ServiceResponse<Status[]>> => {
        const { data } = await http.get<ServiceResponse<Status[]>>("Status/GetAll");
        return data;
    };

}